module.exports = __webpack_public_path__ + "static/media/in-villa-arrow.20c747ae.svg";